import { writable } from 'svelte/store';

const nextq = writable(0);

nextq.subscribe((value) => {
    console.log(value);
}); // logs 0

export default nextq;
